import settings from '../../config/settings';
import _ from 'lodash';
import { renderModes } from '../const/AugmentationConst';

const gaName = 'vupulseGa';
function ga() {
  return window[gaName];
}

function isEnabled() {
  return !!_.get(settings, 'widget.analytics.ga.enableTracking');
}

function hasGa() {
  return (isEnabled() && ga());
}

function sendToPageLoadTracker(hit) {
  if (hasGa() && _.get(settings, 'widget.analytics.ga.pageLoadTrackingId')) {
    ga()('vupPageLoadTracker.send', hit);
  }
}

function sendToEventTracker(hit) {
  if (hasGa() && _.get(settings, 'widget.analytics.ga.eventTrackingId')) {
    ga()('send', hit);
  }
}

function sendToCardEventTracker(hit) {
  if (hasGa() && _.get(settings, 'widget.analytics.ga.cardEventTrackingId')) {
    ga()('vupCardEventTracker.send', hit);
  }
}

function sendToDefaultTrackers(hit) {
  sendToEventTracker(hit);
  sendToPageLoadTracker(hit);
  sendToCardEventTracker(hit);
}

export default class ClientGoogleAnalytics {
  static initialize() {
    if (isEnabled() && !ga()) {
      /* eslint-disable */
      (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
          m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      }(window, document, 'script', '//www.google-analytics.com/analytics.js', gaName));
      /* eslint-enable */

      const eventTrackingId = _.get(settings, 'widget.analytics.ga.eventTrackingId');
      if (eventTrackingId) {
        ga()('create', eventTrackingId, 'auto');
      }

      const pageLoadTrackingId = _.get(settings, 'widget.analytics.ga.pageLoadTrackingId');
      if (pageLoadTrackingId) {
        ga()('create', pageLoadTrackingId, 'auto', 'vupPageLoadTracker');
      }

      const cardEventTrackingId = _.get(settings, 'widget.analytics.ga.cardEventTrackingId');
      if (cardEventTrackingId) {
        ga()('create', cardEventTrackingId, 'auto', 'vupCardEventTracker');
      }
    }
  }

  static sendHostingPageView() {
    if (hasGa()) {
      sendToPageLoadTracker({
        hitType: 'pageview',
        page: document.location.href
      });
    }
  }

  static sendHostingPageViewEvent() {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'Hosting Page',
        eventAction: 'load',
        eventLabel: `page: ${document.location.href}`
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
    }
  }

  static sendCardViewed(mode, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, referrer) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: 'view',
        eventLabel: `mode: ${mode} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId} | referrer: ${referrer}`
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
      sendToCardEventTracker(hit);
    }
  }

  static sendCardRedirectTransitionViewed(mode, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, referrer, destination) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: 'transition viewed',
        eventLabel: `destination: ${destination} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | programId: ${programId} | rendererId: ${rendererId} | showsPageId: ${showsPageId} | referrer: ${referrer}`
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
      sendToCardEventTracker(hit);
    }
  }

  static sendCardShared(media, shareUrl, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: 'share',
        eventLabel: `media: ${media} | target: ${shareUrl} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId}`
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
      sendToCardEventTracker(hit);
    }
  }

  static sendCardDestinationClicked(name, url, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, referrer) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: 'manual selection of destination',
        eventLabel: `name: ${name} | url: ${url} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId} | referrer: ${referrer}`
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
      sendToCardEventTracker(hit);
    }
  }

  static sendTriggerDisplayed(renderMode, displayMode, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, phrase, referrer) {
    if (hasGa()) {
      const renderingLabel = getRenderingLabel(renderMode);
      const eventLabel = `${renderingLabel}mode: ${displayMode} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId} | phrase: ${phrase} | source: ${document.location.href} | referrer: ${referrer}`;

      const hit = {
        hitType: 'event',
        eventCategory: 'Trigger',
        eventAction: 'display',
        eventLabel,
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
    }
  }

  static sendAdReloaded(renderMode, displayMode, rendererId, campaignId) {
    if (hasGa()) {
      const renderingLabel = getRenderingLabel(renderMode);
      const eventLabel = `${renderingLabel}rendererId: ${rendererId} | campaignId: ${campaignId} | source: ${document.location.href}`;

      const hit = {
        hitType: 'event',
        eventCategory: 'Trigger',
        eventAction: 'reload',
        eventLabel,
      };
      sendToEventTracker(hit);
      sendToPageLoadTracker(hit);
    }
  }

  static sendAdClicked(renderMode, rendererId, campaignId, collectionId, url, title, referrer) {
    const renderingLabel = getRenderingLabel(renderMode);
    const eventLabel = `${renderingLabel}rendererId: ${rendererId} | campaignId: ${campaignId} | collectionId: ${collectionId} | url: ${url} | title: ${title} | referrer: ${referrer}`;

    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'Ad',
        eventAction: 'click',
        eventLabel,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendTriggered(renderMode, action, displayMode, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, phrase, referrer) {
    const renderingLabel = getRenderingLabel(renderMode);
    const eventLabel = `${renderingLabel}mode: ${displayMode} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId} | phrase: ${phrase} | referrer: ${referrer}`;

    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'Trigger',
        eventAction: action,
        eventLabel,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendTriggeredUrl(renderMode, action, url, programId, title, rendererId, cardId, campaignId, collectionId, showsPageId, phrase, referrer) {
    const renderingLabel = getRenderingLabel(renderMode);
    const eventLabel = `${renderingLabel}url: ${url} | title: ${title} | programId: ${programId} | rendererId: ${rendererId} | cardId: ${cardId} | campaignId: ${campaignId} | collectionId: ${collectionId} | showsPageId: ${showsPageId} | phrase: ${phrase} | referrer: ${referrer}`;

    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'Trigger',
        eventAction: action,
        eventLabel,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendCardRedirect(cardId, campaignId, action, type, url, device, destination, referrer) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: action,
        eventLabel: `destination: ${destination} | type: ${type} | device: ${device} | url: ${url} | cardId: ${cardId} | campaignId: ${campaignId} | referrer: ${referrer}`
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendCardRequest(cardId, campaignId, type, requestMode, destination) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory: 'VuCard',
        eventAction: type,
        eventLabel: `cardId: ${cardId} | campaignId: ${campaignId} | requestMode: ${requestMode} | destination: ${destination}`,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendProductPageLoad(eventCategory, eventAction, referrer, publisherId, templateId, productDataSourceId, publisherName, productDataSourceName) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel: `publisherId: ${publisherId} | publisherName: ${publisherName} | productDataSourceId: ${productDataSourceId} | productDataSourceName: ${productDataSourceName} | templateId: ${templateId} | referrer: ${referrer}`,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendProductPageProductClick(eventCategory, eventAction, referrer, publisherId, templateId, productDataSourceId, productId, publisherName, productDataSourceName) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel: `productId: ${productId} | publisherId: ${publisherId} | publisherName: ${publisherName} | productDataSourceId: ${productDataSourceId} | productDataSourceName: ${productDataSourceName} | templateId: ${templateId} | referrer: ${referrer}`,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendCommerceUnitEvent(eventCategory, eventAction, referrer, publisherId, templateId, campaignId, rendererId, publisherName) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel: `publisherId: ${publisherId} | publisherName: ${publisherName} | templateId: ${templateId} | campaignId: ${campaignId} | rendererId: ${rendererId} | referrer: ${referrer}`,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendCommerceUnitProductAdEvent(eventCategory, eventAction, referrer, publisherId, templateId, sourceId, productId, campaignId, rendererId, publisherName, sourceName) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel: `productId: ${productId} | publisherId: ${publisherId} | publisherName: ${publisherName} | productDataSourceId: ${sourceId} | productDataSourceName: ${sourceName} | templateId: ${templateId} | campaignId: ${campaignId} | rendererId: ${rendererId} | referrer: ${referrer}`,
      };
      sendToDefaultTrackers(hit);
    }
  }

  static sendCommerceUnitProgrammaticAdEvent(eventCategory, eventAction, referrer, publisherId, templateId, sourceId, campaignId, rendererId, publisherName, sourceName) {
    if (hasGa()) {
      const hit = {
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel: `publisherId: ${publisherId} | publisherName: ${publisherName} | adSourceId: ${sourceId} | adSourceName: ${sourceName} | templateId: ${templateId} | campaignId: ${campaignId} | rendererId: ${rendererId} | referrer: ${referrer}`,
      };
      sendToDefaultTrackers(hit);
    }
  }
}

function getRenderingLabel(renderMode) {
  switch (renderMode) {
    case renderModes.vuline:
      return 'rendering: VuLine | ';
    case renderModes.vuphrase:
      return 'rendering: VuPhrase | ';
    case renderModes.inline:
      return 'rendering: VuButton | ';
    case renderModes.vupopup:
      return 'rendering: Card-based VuPopup | ';
    case renderModes.iframeVupopup:
      return 'rendering: IFrame-based VuPopup | ';
    case renderModes.iframeBottomBanner:
      return 'rendering: IFrame-based Bottom banner | ';
    default:
      return `rendering: ${renderMode} | `;
  }
}
